export const showDetailsPageHeaderTestIDs = {
  header: 'show_details_page_header',
  titleText: 'show_details_page_header_title',
  yearText: 'show_details_page_header_year',
  seasonsText: 'show_details_page_header_seasons',
  ratingText: 'show_details_page_header_rating',
  descriptionText: 'show_details_page_header_description',
  btnReadMore: 'show_details_page_header_btn_read_more',
  btnPlay: 'show_details_page_header_btn_play',
  btnRestart: 'show_details_page_header_btn_restart',
};
